// Copyright (c) 2017 Deere & Company

import Registration from '@deere/cps-it.warranty-model-factory/lib/registration';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const registerAnother = (state, action) =>
    Registration.update(state, {
        $merge: {
            ...action.registration,
            customer: state.customer,
            responsibleDealer: state.responsibleDealer
        }
    });

const updateRegistration = (state, action) =>
    Registration.update(state, {
        $set: action.data
    });

const updateRegistrationProperty = (state, action) =>
    Registration.update(state, {
        [action.property]: {
            $set: action.value
        }
    });

const updateRegistrationLocation = (state, action) =>
    Registration.update(state, {
        responsibleDealer: {
            account: {
                $set: action.location
            }
        }
    });

const updateRegistrationOtherUseAmount = (state, action) =>
    Registration.update(state, {
        otherUseAmount: {
            [action.property]: {
                $set: action.value
            }
        }
    });

const updateRegistrationPin = (state, action) =>
    Registration.update(state, {
        product: {
            pin: {
                $set: action.pin
            }
        }
    });

const updateRegistrationUseAmount = (state, action) =>
    Registration.update(state, {
        useAmount: {
            [action.property]: {
                $set: action.value
            }
        }
    });

export default (state = getDefaultState().registration, action) => {

    const actionTypes = {
        [actions.PRODUCT_REGISTRATION_REGISTER_ANOTHER_PRODUCT]: registerAnother,
        [actions.RESET_PRODUCT_REGISTRATION]: updateRegistration,
        [actions.UPDATE_PRODUCT_REGISTRATION]: updateRegistration,
        [actions.UPDATE_PRODUCT_REGISTRATION_REGISTRATION]: updateRegistrationProperty,
        [actions.UPDATE_PRODUCT_REGISTRATION_REGISTRATION_LOCATION]: updateRegistrationLocation,
        [actions.UPDATE_PRODUCT_REGISTRATION_REGISTRATION_OTHER_USE_AMOUNT]: updateRegistrationOtherUseAmount,
        [actions.UPDATE_PRODUCT_REGISTRATION_REGISTRATION_PIN]: updateRegistrationPin,
        [actions.UPDATE_PRODUCT_REGISTRATION_REGISTRATION_USE_AMOUNT]: updateRegistrationUseAmount
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/product-registration/reducers/registration.js